import React from "react";

const Page = ({
  style = {},
  width = 16,
  className = "",
  color = "#ffffff",
  backgroundColor = "none",
  viewBox = "0 0 16 22",
  ...rest
}) => {
  return (
    <svg
      width={width}
      className={className}
      style={style}
      viewBox={viewBox}
      {...rest}
    >
      <path
        fill={color}
        fillRule="nonzero"
        d="M10.59.98C10.21.58 9.7.36 9.17.36H2c-1.1 0-2 .94-2 2.1v16.8c0 1.15.89 2.1 1.99 2.1H14c1.1 0 2-.95 2-2.1V7.53c0-.56-.21-1.1-.59-1.48L10.59.98zM11 17.16H5c-.55 0-1-.47-1-1.05 0-.58.45-1.05 1-1.05h6c.55 0 1 .47 1 1.05 0 .58-.45 1.05-1 1.05zm0-4.2H5c-.55 0-1-.47-1-1.05 0-.58.45-1.05 1-1.05h6c.55 0 1 .47 1 1.05 0 .58-.45 1.05-1 1.05zm-2-6.3V1.93l5.5 5.78H10c-.55 0-1-.47-1-1.05z"
      />
    </svg>
  );
};

export default Page;
